import { InternalAxiosRequestConfig } from 'axios';
import { LocalStorageItems } from 'shared/constants';

import getJwtAuthToken from './getJwtAuthToken';
import getStaticCandidateToken from './getStaticCandidateToken';
import { InterceptorArgs } from './interceptors';

export default async function onBeforeRequest(args: InterceptorArgs, config: InternalAxiosRequestConfig) {
    await setAuthHeadersOnRequest(config, args);
}

async function setAuthHeadersOnRequest(config: InternalAxiosRequestConfig, args: InterceptorArgs) {
    setTenantIdHeader(config);
    await setAuthTokenHeader(args, config);
}

async function setAuthTokenHeader(args: InterceptorArgs, config: InternalAxiosRequestConfig) {
    // eslint-disable-next-line no-underscore-dangle, @typescript-eslint/no-explicit-any
    const isRetry = (config as any)._retry;
    const tokenResponse = await getJwtAuthToken(args.msalInstance, isRetry);
    let token = tokenResponse.token;

    if (!token) {
        token = getStaticCandidateToken();
    }

    if (token) {
        config.headers.Authorization = `Bearer ${ token }`;
    }
}

function setTenantIdHeader(config: InternalAxiosRequestConfig) {
    const tenantId = getTenantId();
    config.headers['AuthTenantId'] = tenantId;
}

function getTenantId(): string | null {
    return localStorage.getItem(LocalStorageItems.TENANT_ID);
}
